import {
  sendPostRequest, sendGetRequest, sendPutRequest, sendDeleteRequest}
  from '../requests';
import {GetGroupProps, CreateGroupProps} from '../../constants/types';

const baseUrl = '/groups';

export const addGroup = (data: CreateGroupProps) =>
  sendPostRequest(baseUrl, data);

export const getGroups = (params: GetGroupProps) =>
  sendGetRequest(baseUrl, params);

export const getGroupById = (entity: string) =>
  sendGetRequest(`${baseUrl}/${entity}`);

export const getGroupsByTenant = (id: number) =>
  sendGetRequest(`/tenants/${id}${baseUrl}`);

export const getAvailableGroups = () =>
  sendGetRequest(`/tenants/available-groups`);

export const updateGroupById = (entity: string, body) =>
  sendPutRequest(`${baseUrl}/${entity}`, body);

export const deleteGroupById = (entity: string) =>
  sendDeleteRequest(`${baseUrl}/${entity}`);

export const removeTenantFromGroup = (
    groupId: string,
    tenantId: string
) => sendDeleteRequest(`${baseUrl}/${groupId}/tenants/${tenantId}`);

export const addTenantsToGroup = (groupId: string, body: number[]
) => sendPostRequest(`${baseUrl}/${groupId}/tenants`, body);
